import { useState } from "react";
import { API_BASE } from "../config";
import { apiFetch } from "../utilities/apiFetch";

const useHistorialPagos = () => {
  const [historialPagos, setHistorialPagos] = useState([]);
  const [cargandoHistorial, setCargandoHistorial] = useState(false);

  const obtenerHistorialAlumno = async (matricula) => {
    setCargandoHistorial(true);
    try {
      const respuesta = await apiFetch(`${API_BASE}/wMultipagosObtenerHistorial.php?matricula=${matricula}`);
      const resultado = await respuesta.json();
      
      if (resultado.success) {
        setHistorialPagos(resultado.data);
      } else {
        setHistorialPagos([]);
      }
    } catch (error) {
      console.error("Error al cargar el historial:", error);
      alert("Hubo un error al conectar con el servidor para obtener el historial.");
      setHistorialPagos([]);
    } finally {
      setCargandoHistorial(false);
    }
  };

  return {
    historialPagos,
    cargandoHistorial,
    obtenerHistorialAlumno
  };
};

export default useHistorialPagos;